var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('sdg-logo');
import { breakpoints } from '@shapeable/theme';
import { ImageEntity } from './image-entity';
import { useEntity } from '../hooks/use-entity';
export var SdgLogoDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    height: 68px;\n    width: 68px;\n    flex-direction: column;\n    gap: 8px;\n    overflow: hidden;\n    align-content: center;\n  "], ["\n    display: flex;\n    height: 68px;\n    width: 68px;\n    flex-direction: column;\n    gap: 8px;\n    overflow: hidden;\n    align-content: center;\n  "])))
});
var ImageStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 120%;\n    height: 120%;\n    object-fit: cover;\n    object-position: center center;\n\n  "], ["\n    width: 120%;\n    height: 120%;\n    object-fit: cover;\n    object-position: center center;\n\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Image: styled(ImageEntity)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles)
};
export var SdgLogo = function (props) {
  var className = props.className,
    children = props.children;
  var entity = useEntity(props.entity);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Image, {
    entity: entity.openGraph
  }));
};
SdgLogo.defaultProps = SdgLogoDefaultProps;
SdgLogo.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;